import { render, staticRenderFns } from "./module-caizhi.vue?vue&type=template&id=cffaaa96&scoped=true"
import script from "./module-caizhi.vue?vue&type=script&lang=js"
export * from "./module-caizhi.vue?vue&type=script&lang=js"
import style0 from "./module-caizhi.vue?vue&type=style&index=0&id=cffaaa96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffaaa96",
  null
  
)

export default component.exports